import DTSBanner from './DTSBanner';

export default DTSBanner;
